<!--
component: BrowseImage
author: Ken Nakamura
description: 画像閲覧コンポーネント
-->
<template>
  <section :class="paper">
    <!--<img :src="imageUrl" width="93%" height="93%"/>-->
    <!--<img :src="imageUrl" width="100%" height="100%"/>-->
    <img :src="imageUrl" height="100%"/>
    <span class="description">
      <div v-for="(desc, index) in descText" :key="index" class="description">
      {{desc}}
      </div>
    </span>
  </section>
</template>

<script>
export default {
  props: {
    sourceImage: {
      type: HTMLImageElement ,
      default: null,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    paper: {
      type: String,
      default: 'A4',
    },
    descText: {
      type: Array,
      default: null,
    },
  },
  watch: {
    /*
    paper: {
      immediate: true,
      handler(value) {
        console.log(value);
      }
    }
    */
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.A4 {
  //width: 210mm;
  //height: 296mm;
  width: 190mm !important;
  height: 276mm !important;
  //width: 172mm;
  //height: 251mm;
  page-break-after: auto;
  background: none;
}
.A4R {
  width: 296mm;
  height: 210mm;
  page-break-after: auto;
  background: none;
}
.A3 {
  width: 296mm;
  height: 420mm;
  page-break-after: auto;
  background: none;
}
.A3R {
  //width: 420mm;
  //height: 296mm;
  width: 400mm;
  height: 276mm;
  margin: 0mm;
  page-break-after: none;
  background: none;
  //margin: 25mm 15mm 0 0;
  //padding: 25mm 15mm 0 0;
}
.description {
  font-family: 'MS Gothic';
  font-size: 10.5pt;
  padding-left: 10mm;
}
@media print {
  @page {
    size: A3 landscape;
    margin: 0;
    padding: 0;
    background: none;
  }
  body {
    margin: 0mm;
    padding: 0;
    background: none;
  }
  main {
    margin: 0mm;
    padding: 0;
    background: none;
  }
.A3R {
  //width: 420mm;
  //height: 296mm;
  //width: 400mm;
  width: auto;
  height: 100%;
  //margin: -25mm 15mm 15mm -25mm;
  padding: -25mm 15mm;
}
}
</style>